import React from "react";
import "./DescriptionBox.css";

const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="discriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade-review">Reviews (121)</div>
      </div>
      <div className="descriptionbox-descrition">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est totam
          animi tenetur nisi. Iste dolorum modi, mollitia est, maxime totam
          numquam odio quia ratione molestias doloribus! Recusandae ad
          consequuntur explicabo? Nostrum tempora earum amet laborum mollitia
          maxime, aliquid quod in excepturi animi, neque asperiores, impedit
          esse quae dolor voluptates laudantium corrupti? Cumque qui
          reprehenderit sed laboriosam facere consectetur, eius molestias!
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Qui
          voluptates odit ea adipisci? Ad adipisci fugiat nobis, nihil eius,
          odit, ipsum voluptates eaque deleniti fugit incidunt numquam eveniet
          expedita nemo.
        </p>
      </div>
    </div>
  );
};

export default DescriptionBox;
